import { GET_USERS, POST_USER } from "../actions/actionUser";

const initialState = {
    allUsers: [],
    postUsers: {}    
}

export default function reducerUser(state = initialState, action){
    switch (action.type) {
        case GET_USERS:
            return {
                ...state,
                allUsers: action.payload
            }
        case POST_USER:
            return {
                ...state,
                postUsers: action.payload
            }           
            default:
                return {...state}
        }            
}